export default {
  filter: '',
  users: []
}
